import Button from "devextreme-react/button";
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AR, OrderStatus, ROType } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";
import { RetailOrderProgressStep } from "../types/RetailOrderProgressStep";

export default function ChangeOrderButton(props: { step: RetailOrderProgressStep }) {

	const navigate = useNavigate();
	const { order } = useContext(RetailOrderContext);

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");

	const isCabinetInstallOrder = order.details.roTypeID === ROType.CabinetInstallOrder &&
		order.details.orderStatusID !== OrderStatus.Cancelled &&
		order.details.orderStatusID !== OrderStatus.Closed;

	const changeOrderEditable = order.details.changeOrderProducts?.filter(x => x.roProductChangeRequestID > 0).length > 0 &&
		(order.details.activeARs.includes(AR.DealerToConfirmChangeOrder) ||
			(order.details.roTypeID === ROType.Plumbing && order.details.activeARs.includes(AR.CfiToUploadCocInvoice)) ||
			isCabinetInstallOrder);

	const changeOrderAvailable = (order.details.activeARs.includes(AR.CfiToConfirmOrChangeOrder) || changeOrderEditable || isCabinetInstallOrder) &&
		order.details.roTypeID !== ROType.Display && order.details.roTypeID !== ROType.DisplayAdmin;

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-change-order' }}
				text={changeOrderEditable ? "Edit Change Order" : "Change Order"}
				icon="Inscyth-Change"
				visible={changeOrderAvailable && (isCabinetInstallOrder || (!isCabinetInstallOrder && props.step === RetailOrderProgressStep.Confirm))}
				disabled={order.details.orderStatusID === OrderStatus.Pending}
				onClick={(e) => {
					navigate(`/cfi/retail-order/${order.details.retailOrderID}/120/change-order` +
						(!!returnUrl ? '?returnUrl=' + returnUrl : ''));
				}} >
			</Button>
		</>
	)
}
